import React, { useState, useEffect, useContext } from 'react';
// --- IMPORTA downloadTutorial ---
import { getTutorials, deleteTutorial, createTutorial, updateTutorial, downloadTutorial } from '../api/api';
import TutorialForm from '../components/TutorialForm';
import { AuthContext } from '../context/AuthContext';
import '../index.css';
import './Users.css'; // Se usa el css de users
import Table from '../components/common/Table'; // Importar Table
import Header from '../components/common/Header';
import Search from '../components/common/Search';
import Button from '../components/common/Button';
import Error from '../components/common/Error';
import { saveAs } from 'file-saver';


const Tutorials = () => {
    const [tutorials, setTutorials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [tutorialToEdit, setTutorialToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState(''); // Estado para el buscador
    const { userRole } = useContext(AuthContext);

    const canCreate = userRole === "Director";
    const canUpdate = userRole === "Director";
    const canDelete = userRole === "Director";
    const canRead = userRole === "Director" || userRole === "Navegador" || userRole === "Lector";

    useEffect(() => {
        const fetchTutorials = async () => {
            setLoading(true);
            setError(null); // Limpiar error previo
            try {
                const tutorialsData = await getTutorials();
                setTutorials(tutorialsData);
            } catch (err) {
                setError(err.message || 'Error al cargar los tutoriales');
            } finally {
                setLoading(false);
            }
        };
        if (canRead) {
            fetchTutorials();
        } else {
            setError("No tienes permisos para ver los tutoriales");
            setLoading(false); // Asegura que loading termine si no hay permisos
        }
    }, [canRead, userRole]);

    const handleCreate = () => {
        setTutorialToEdit(null);
        setShowForm(true);
    };

    const handleEdit = (tutorial) => {
        setTutorialToEdit(tutorial);
        setShowForm(true);
    };

    const handleDelete = async (id) => {
        setError(null); // Limpiar error previo
        try {
            await deleteTutorial(id);
            setTutorials(tutorials.filter(tutorial => tutorial.id !== id));
        } catch (err) {
            setError(err.message || 'Error al eliminar el tutorial');
        }
    };

    const handleCloseForm = () => {
        setShowForm(false);
        setTutorialToEdit(null);
    }

    const handleTutorialUpdated = (newTutorial) => {
        setTutorials(tutorials.map((tutorial) => (tutorial.id === newTutorial.id ? newTutorial : tutorial)))
    }

    const handleTutorialCreated = (newTutorial) => {
        setTutorials([...tutorials, newTutorial])
    }

    // --- handleDownload MODIFICADO ---
    const handleDownload = async (id) => {
      setError(null); // Limpiar error previo
      try {
          // Llama a la nueva función de api.js
          const { blob, filename } = await downloadTutorial(id);
          // Usa file-saver para iniciar la descarga
          saveAs(blob, filename);
      } catch (err) {
          // Usa el mensaje de error proporcionado por downloadTutorial
          setError(err.message || "Error desconocido al descargar el archivo.");
      }
    }
    // --- Fin de handleDownload MODIFICADO ---

    // Función para filtrar los tutoriales
    const filteredTutorials = tutorials.filter((tutorial) => {
        // Asegurarse que tutorial no sea null o undefined antes de acceder a sus valores
        if (!tutorial) return false;
        const tutorialValues = Object.values(tutorial).join('').toLowerCase();
        return tutorialValues.includes(searchTerm.toLowerCase());
    });

    if (loading) return <div>Cargando...</div>;
    // Mostrar error si existe
    // {error && <Error error={error} />} {/* Movido dentro del return principal */}

    const tableHeaders = ["Título", "Tema", "Texto", "Tipo", "URL/Archivo", "Acompañamiento", "Acciones"];

    // Función para truncar el texto
    const truncateText = (text, maxLength) => {
        if (!text) return ""; // Manejar texto nulo o undefined
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    };

    const renderTutorialRow = (tutorial) => {
        // Añadir verificación por si un tutorial es null/undefined en los datos filtrados
        if (!tutorial) return null;

        return [
            truncateText(tutorial.title, 30),
            truncateText(tutorial.topic, 30),
            truncateText(tutorial.text, 30),
            tutorial.type,
            // Lógica para mostrar enlace o botón de descarga
            tutorial.url
                ? <a href={tutorial.url} target="_blank" rel="noopener noreferrer">Ver URL</a>
                : tutorial.file_path
                    ? <Button onClick={() => handleDownload(tutorial.id)}>Descargar</Button>
                    : "N/A",
            tutorial.accompaniment ? "Sí" : "No",
            // Array de botones de acción
            [
                canUpdate && <Button key={`edit-${tutorial.id}`} onClick={() => handleEdit(tutorial)}>Editar</Button>,
                canDelete && <Button key={`delete-${tutorial.id}`} onClick={() => handleDelete(tutorial.id)}>Eliminar</Button>
            ].filter(Boolean) // Filtra elementos falsy (si un botón no se renderiza por permisos)
        ];
    };


    return (
        <div className='container'>
            <Header title="Gestión de Tutoriales" />
            {/* Mostrar error si existe */}
            {error && <Error error={error} />}
            <Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            {canCreate && <Button onClick={handleCreate}>Crear Tutorial</Button>}
            {showForm && (
                <div className='container-form'>
                    <TutorialForm
                        onClose={handleCloseForm}
                        tutorial={tutorialToEdit}
                        onTutorialUpdated={handleTutorialUpdated}
                        onTutorialCreated={handleTutorialCreated}
                    />
                </div>
            )}
            {/* Asegurarse que data no sea null/undefined antes de pasarla a Table */}
            <Table headers={tableHeaders} data={filteredTutorials || []} renderRow={renderTutorialRow} />
        </div>
    );
};

export default Tutorials;
